export class PageOptionSelector {
    public value: number = 0;
    public label: string = "";
    public checked: boolean;
    public visible: boolean = true;
    /* Links another page to the current one. If this page is checked, the same behavior will be sync with the linked page. */
    public pageLink: number = null;

    constructor(init?: Partial<PageOptionSelector>) {
        Object.assign(this, init);
    }
}
